import Vue from 'vue';
import i18next from 'i18next';
import { LOCALES } from '@/core/i18n/constants';

export function removeDiacritics(value: string = '', forceDiacritics: boolean = false) {
    return i18next.language === LOCALES.Greek || forceDiacritics
        ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        : value;
}

Vue.filter('uppercase', (value: string) => removeDiacritics(value).toUpperCase());
